export default "__VITE_ASSET__DswacWHs__"